(function($) {
    $(".page-links-row a[href]").each(function() {
        if (this.href == window.location.href) {
            $(this).addClass("active");
        }
    });
})(jQuery);